import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyloadDirective } from 'src/app/directives/lazyload.directive';
import { BannerComponent } from 'src/app/view/shared/banner/banner.component';
import { LoaderComponent } from 'src/app/view/shared/loader/loader.component';
import { ButtonComponent } from 'src/app/view/shared/button/button.component';


@NgModule({
  declarations: [
    LazyloadDirective,
    BannerComponent,
    LoaderComponent,
    ButtonComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[
    LazyloadDirective,
    BannerComponent,
    LoaderComponent,
    ButtonComponent
  ]
})
export class SharedModule { }
